module.exports = __webpack_public_path__ + "static/media/icons8-tiktok-500.812a6cdd.png";